import type { SanityHeaderFooterLayoutProps } from '../../../../js/layout/SanityHeaderFooterLayout';
import SanityHeaderFooterLayout from '../../../../js/layout/SanityHeaderFooterLayout';
import Breadcrumbs from '../../../../js/sanity/components/Breadcrumbs';
import Header from '../../../../js/sanity/components/Header';
import LinedHeading from '../../../../js/sanity/components/LinedHeading';
import { FilterableGrid } from '../../../../js/sanity/grid/FilterableGrid';
import type { TaggedGridItemProps } from '../../../../js/sanity/grid/TaggedGridItem';
import TaggedGridItem from '../../../../js/sanity/grid/TaggedGridItem';
import SanityPage from '../../../../js/sanity/infrastructure/SanityPage';
import type { ListPageFor } from '../../../../js/sanity/page/ListPage/groq';
import { RichText } from '../../../../js/sanity/richTextComponents';
import GridBlock from '../../../../js/sanity/richTextComponents/grid';

export default SanityPage<ListPageFor<TaggedGridItemProps>>(({ page, url, breadcrumbs }) => (
    <article className="sanity" lang={page.metadata?.language}>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <Header title={page.title} ingress={page.ingress} />
        <section>
            <RichText value={page.richText} studioPath="richText" />
        </section>
        <GridBlock value={page.grid} />
        <LinedHeading>{page.subtitle}</LinedHeading>
        <FilterableGrid items={page.list} component={TaggedGridItem} selectedTags={url.searchParams.getAll('tag')} />
    </article>
));

export function StaticLayout({ props, url }: SanityHeaderFooterLayoutProps) {
    return <SanityHeaderFooterLayout props={props} url={url} dynamic />;
}

// Force this file to be treated as a page
export const onRequest = () => null;
export const path = __FILE_PATH__;
